<script setup>
import { ref, watch } from 'vue';
import Draggable from 'vuedraggable';
import OpportunityCard from './OpportunityCard.vue';

const props = defineProps({
  stages: { type: Array, required: true },
  opportunitiesByStage: { type: Object, required: true },
});

const emit = defineEmits(['move', 'show']);

const columns = ref({});

watch(
  () => props.opportunitiesByStage,
  grouped => {
    props.stages.forEach(stage => {
      columns.value[stage.key] = [...(grouped[stage.key] || [])];
    });
  },
  { immediate: true, deep: true }
);

const onChange = (stageKey, event) => {
  if (!event.added) return;
  emit('move', { id: event.added.element.id, stage: stageKey });
};
</script>

<template>
  <div class="flex w-full h-full gap-4 px-6 py-4 overflow-x-auto">
    <div
      v-for="stage in stages"
      :key="stage.key"
      class="flex flex-col flex-shrink-0 w-72 bg-n-background rounded-lg"
    >
      <div class="flex items-center justify-between px-3 py-2">
        <span class="text-sm font-semibold text-n-slate-12">{{
          stage.label
        }}</span>
        <span class="text-xs text-n-slate-11">{{
          (columns[stage.key] || []).length
        }}</span>
      </div>
      <Draggable
        :list="columns[stage.key]"
        group="opportunity-stage"
        item-key="id"
        animation="200"
        ghost-class="ghost"
        class="flex flex-col flex-1 gap-2 p-2 min-h-[4rem]"
        @change="onChange(stage.key, $event)"
      >
        <template #item="{ element }">
          <OpportunityCard
            :name="element.name"
            :value="element.value"
            :currency="element.currency"
            :expected-close-date="element.expectedCloseDate"
            :manual-probability="element.manualProbability"
            @click="emit('show', element.id)"
          />
        </template>
      </Draggable>
    </div>
  </div>
</template>
